import { render, staticRenderFns } from "./Register-v3.vue?vue&type=template&id=59641c6b&"
import script from "./Register-v3.vue?vue&type=script&lang=js&"
export * from "./Register-v3.vue?vue&type=script&lang=js&"
import style0 from "./Register-v3.vue?vue&type=style&index=0&id=59641c6b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports